import { Skeleton } from '@mui/material';

export const BotMessageLoading = () => (
  <>
    <Skeleton variant="text" width="100%" sx={{ lineHeight: '1rem' }} />
    <Skeleton variant="text" width="83%" sx={{ lineHeight: '1rem' }} />
    <Skeleton variant="text" width="80%" sx={{ lineHeight: '1rem' }} />
  </>
);
